export default __webpack_public_path__ + "static/media/cra-assets-01.b9232c5b.svg";